import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyBz-oC2Fn-Hsawu2TvO8cKqTl75KCdcAI0',
  authDomain: 'bateristico-playlist.firebaseapp.com',
  projectId: 'bateristico-playlist',
  storageBucket: 'bateristico-playlist.appspot.com',
  messagingSenderId: '805072025774',
  appId: '1:805072025774:web:fdcbf50f1f0948b102d53f',
};

// init firebase
firebase.initializeApp(firebaseConfig);

// init services
const projectFirestore = firebase.firestore();
const projectAuth = firebase.auth();
const projectStorage = firebase.storage();

// timestamp
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { projectFirestore, projectAuth, projectStorage, timestamp };
